import React from 'react';
import {
  Typography,
  Stack,
  Box,
  type StackProps,
  type TypographyProps
} from '@mui/material';

type Props = {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  variant?: TypographyProps['variant'];
  stackProps?: StackProps;
};

const PageHeader: React.FC<Props> = ({
  title,
  subtitle,
  action,
  variant = 'h4',
  stackProps
}) => {
  const hasAction = Boolean(action);

  if (hasAction) {
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
        {...stackProps}
      >
        <Box>
          <Typography variant={variant} component="h1">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action}
      </Stack>
    );
  }

  return (
    <Box mb={3}>
      <Typography variant={variant} component="h1" gutterBottom>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader;
